// import MaterialIcon from "common/MaterialIcon/MaterialIcon";
// Type - Primary (Primary Color background with white text)
// Type - Secondary (White background with Primary Color text)
// Type - Make Changes (Edit Icon inside the button, white background, primary color text)

const Button = ({
  wrapperClassName = "",
  buttonClassName = "",
  type = "primary",
  text = "",
  click = () => {},
  disabled = false,
  id = "",
  ariaLabel = "",
}) => {
  return (
    <div className={`common-button ${wrapperClassName}`}>
      <button
        className={`form-control h-100 ${type} ${buttonClassName} ${
          disabled ? "disabled" : ""
        }`}
        onClick={() => {
          click();
        }}
        disabled={disabled}
        id={id}
        aria-label={ariaLabel}
        type="button"
      >
        {text}
      </button>
    </div>
  );
};

export default Button;
